import { render, staticRenderFns } from "./EditDepartmentModal.vue?vue&type=template&id=546b7d79"
import script from "./EditDepartmentModal.vue?vue&type=script&lang=js"
export * from "./EditDepartmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports